<div class="mb-3">
  <!-- Label -->
  @if (label) {
    <label [for]="generatedId" class="form-label">
      {{ label }}
      @if (required) {
        <span class="text-danger">*</span>
      }
    </label>
  }

  <!-- Select -->
  <select
    [id]="generatedId"
    class="form-select"
    [class]="sizeClass"
    [class.is-invalid]="hasError"
    [disabled]="disabled"
    [value]="selectedValue"
    (change)="onSelectChange($event)"
    (blur)="onBlur()">

    <!-- Placeholder option -->
    @if (placeholder) {
      <option value="" [disabled]="required" [selected]="selectedValue === null">
        {{ placeholder }}
      </option>
    }

    <!-- Options -->
    @for (option of options; track option) {
      <option
        [value]="option.value"
        [disabled]="option.disabled"
        [selected]="selectedValue === option.value">
        {{ option.label }}
      </option>
    }
  </select>

  <!-- Error message -->
  @if (hasError) {
    <div class="invalid-feedback d-block">
      {{ errorMessage }}
    </div>
  }

  <!-- Hint -->
  @if (hint && !hasError) {
    <small class="form-text text-muted">
      {{ hint }}
    </small>
  }
</div>
